export const AppConstants = {
    HOSPITAL_NAME_LIST: [{
            name: "Weiss Memorial Hospital"
        },
        {
            name: "Advocate Illinois Masonic Medical Center"
        },
        {
            name: "Swedish Hospital"
        },
        {
            name: "AMITA Saint Joseph Hospital"
        },
        {
            name: "John H Stroger - Hospital of Cook County"
        },
        {
            name: "Rush University Medical Center"
        },
        {
            name: "Northwestern Medicine Prentice Women's Hospital"
        },
        {
            name: "Mount Sinai Hospital"
        },
    ],
    SPECIALITIES_LIST: [{
        name: 'General Practice'
    }, {
        name: 'Nephrology'
    }, {
        name: 'Cardiology'
    }, {
        name: 'Oncology'
    }, {
        name: 'Pediatrics'
    }, {
        name: 'Wellness'
    }, {
        name: 'Internal Medicine'
    }, {
        name: 'Gastroentologyy'
    }],
    APPOINTMENT_STATUS_LIST: [{
        name: 'BOOKED'
    }, {
        name: 'CONFIRMED'
    }, {
        name: 'CANCELED'
    }, {
        name: 'RESCHEDULED'
    }, {
        name: 'BLOCKED'
    }, {
        name: 'CHECKED_IN'
    }, {
        name: 'COMPLETED'
    }],

    USER_STATUS_LIST: [{
        label: 'Active',value:'ACTIVE'
    }, {
        label: 'Inactive',value:'INACTIVE'
    }],
    PATIENT_RELATION_SHIP_LIST : [{
        label: 'Parent',value:'Parent'
    }, {
        label: 'Child',value:'Child'
    }, {
        label: 'Spouse',value:'Spouse'
    }, {
        label: 'Partner',value:'Partner'
    }, {
        label: 'Friend',value:'Friend'
    },{
        label: 'Other relative',value:'Other relative'
    }],
    SECRET_QUES_LIST:[{
        label: "Best friend's name"
    }, {
        label: "Make of 1st car"
    }, {
        label: "Mother's maiden name"
    }, {
        label: "Name of elementary school"
    }, {
        label: "Nickname growing up"
    }]
    
    
    
    
    

};